import React from 'react'
import { Menu, Icon } from 'antd'
import _ from 'lodash'
import { withRouter, Route } from 'react-router-dom'
import ROUTERARRAY from '../public/global'
const { SubMenu } = Menu
// 路由数据

class RouteSubMenuList extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      defaultSelectedKey: '',
      defaultkey: '',
      defaultkeyarr: [],
      showRouter: false
    }
  }
  componentDidMount () {
    // console.log(ROUTERARRAY)
    // console.log(this.props)
    this.findDefaultSelectedKey()
  }
  findDefaultSelectedKey = () => {
    let _href = window.location.pathname
    let allRouterList = _.flatten(this.props.allRouter)
    let {defaultkey,defaultkeyarr} = this.state
    let searchDefaultarr = []
    let searchDefault = (arr, href, flag = false) => {
      arr.forEach(i => {
        if (flag) {
          searchDefaultarr = []
        }
        if (i.url && i.url == href) {
          defaultkey = ((i.value || i.name) + '&' + i.url)
          searchDefaultarr.push(defaultkey)
          defaultkeyarr = JSON.parse(JSON.stringify(searchDefaultarr))
          return defaultkey
        } else if (i.hasOwnProperty('urlArray') && i.urlArray.length) {
          searchDefaultarr.push(i.name)
          return searchDefault(i.urlArray, href)
        }
      })
    }
    searchDefault(allRouterList, _href, true)
    this.setState({
      defaultkey: defaultkey,
      defaultkeyarr: defaultkeyarr,
      showRouter: true
    })
  }
  goSubRoute = (e) => {
      this.props.history.push(e.key.split('&')[1])
      document.title = e.key.split('&')[0]
    }
    render () {
      let routemodules
      // this.props.routeData.map((paritem, parindex) => {
      let _SubMenu = this.props.routeData.map((item, index) => {
        if (item['urlArray']) {
          let _item = item['urlArray'].map((subitem, subindex) => {
            if (subitem['name']) {
              return (
                <SubMenu key={subitem['name']} title={<span><Icon type="user" /><span style={{'display': (this.props.collpsed ? 'none' : 'inline')}}>{subitem['name']}</span></span>} >
                  {subitem['urlArray'].map((item, index) => {
                    return (
                      <Menu.Item onClick={this.goSubRoute} key={`${item['value']}&${item['url']}`}>
                        <span>{item['value']}</span>
                      </Menu.Item>
                    )
                  })}
                </SubMenu>
              )
            } else {
              return (
                <Menu.Item onClick={this.goSubRoute} key={`${subitem['value']}&${subitem['url']}`}>
                  <Icon type="user" />
                  <span>{subitem['value']}</span>
                </Menu.Item>)
            }
          })
          return (
            <SubMenu key={item['name']} title={<span><Icon type="folder" /><span style={{'display': (this.props.collpsed ? 'none' : 'inline')}}>{item['name']}</span></span>} >
              {_item}
            </SubMenu>
          )
        } else {
          return (
            <Menu.Item onClick={this.goSubRoute} key={`${item['name']}&${item['url']}`}>
              <Icon type="file" />
              <span style={{'display': (this.props.collpsed ? 'none' : 'inline')}}>{item['name']}</span>
            </Menu.Item>
          )
        }
      })
      routemodules = <Menu
        mode="inline" onClick={this.handleClick}
        defaultSelectedKeys={ [(this.state.defaultkey)] }
        defaultOpenKeys={ this.state.defaultkeyarr }
        style={{ height: '100%' }}
      >
        {_SubMenu}
      </Menu>
      // })
      return (
        <div>
          {this.state.showRouter ? routemodules : null }
        </div>)
    }
}
export default withRouter(RouteSubMenuList)



// WEBPACK FOOTER //
// ./src/compenents/RouteSubMenuList.js